import confetti from "canvas-confetti";

/**
 * Fires a celebratory confetti burst from the bottom of the page.
 * Used after a successful resume parse.
 */
export function celebrate() {
  const colors = ["#155E75", "#0E7490", "#06B6D4", "#F59E0B", "#FBBF24", "#10B981"];
  const defaults = {
    spread: 70,
    ticks: 60,
    gravity: 1,
    decay: 0.94,
    startVelocity: 30,
    colors,
    disableForReducedMotion: true,
  };

  confetti({
    ...defaults,
    particleCount: 40,
    origin: { x: 0.2, y: 0.85 },
    angle: 60,
  });
  confetti({
    ...defaults,
    particleCount: 40,
    origin: { x: 0.8, y: 0.85 },
    angle: 120,
  });
  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 60,
      origin: { x: 0.5, y: 0.85 },
      spread: 90,
      scalar: 1.1,
    });
  }, 180);
}

/** Small subtle "task complete" sparkle (less intense than `celebrate`). */
export function sparkle() {
  confetti({
    particleCount: 18,
    spread: 50,
    startVelocity: 22,
    gravity: 0.7,
    ticks: 40,
    colors: ["#F59E0B", "#FBBF24", "#155E75", "#06B6D4"],
    origin: { y: 0.7 },
    scalar: 0.7,
    disableForReducedMotion: true,
  });
}
